import { GRAY_JOB_RECEIVE_RETURN_REQUEST, CREATE_GRAY_JOB_RECEIVE_RETURN, GET_GRAY_JOB_RECEIVE_RETURNS, UPDATE_GRAY_JOB_RECEIVE_RETURN, DELETE_GRAY_JOB_RECEIVE_RETURN,
    GRAY_JOB_RECEIVE_RETURN_REQUEST_FAILURE } from '../types';

const initialState = {
  grayJobReceiveReturns: [],
  loading: false,
  error: null,
};

const grayJobReceiveReturnReducer = (state = initialState, action) => {
  switch (action.type) {
    case GRAY_JOB_RECEIVE_RETURN_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_GRAY_JOB_RECEIVE_RETURNS: {
      return {
        ...state,
        grayJobReceiveReturns: [...action.payload],
        loading: false,
        error: null
      }
    }
    case CREATE_GRAY_JOB_RECEIVE_RETURN:
      return {
        ...state,
        grayJobReceiveReturns: [action.payload, ...state.grayJobReceiveReturns],
        loading: false,
        error: null
      };
    case UPDATE_GRAY_JOB_RECEIVE_RETURN:
      const grayJobReceiveReturnsData = state.grayJobReceiveReturns.slice(0);
      const uIndex = grayJobReceiveReturnsData.findIndex((data) => data.id === action.payload.id);
      grayJobReceiveReturnsData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        grayJobReceiveReturns: [ ...grayJobReceiveReturnsData ],
        loading: false,
        error: null
      };
    case DELETE_GRAY_JOB_RECEIVE_RETURN:
      const grayJobReceiveReturns = state.grayJobReceiveReturns?.slice(0);
      const index = grayJobReceiveReturns.findIndex((data) => data.id === action.id);
      if (index > -1) {
        grayJobReceiveReturns.splice(index, 1);
      }
      return {
        ...state,
        grayJobReceiveReturns: [...grayJobReceiveReturns],
        loading: false,
        error: null
      }
    case GRAY_JOB_RECEIVE_RETURN_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default grayJobReceiveReturnReducer;
